import React from 'react';
import { useFeature } from '@mafc/appshell';
import NewCardForm from './NewCardForm';
import MasterCardForm from './MasterCardForm';
import usePaymentService from 'services/payments/hooks/usePaymentService.hook';

export default ({
  paymentDetails,
  saveCard,
  disabled,
}: {
  paymentDetails: any;
  saveCard: boolean;
  disabled: boolean;
}) => {
  const isCheckoutDotComSupported = useFeature('checkout-dot-com-supported').on;

  const { isMasterCardEnabled } = usePaymentService(); // mastercard

  if (isMasterCardEnabled && !isCheckoutDotComSupported) {
    return <MasterCardForm disabled={disabled} />;
  }
  return <NewCardForm saveCard={saveCard} paymentDetails={paymentDetails} disabled={disabled} />;
};
